import { CultureInfo } from '../culture-info.model';
import { CultureInfoCa } from './ca';

/**
 * @ignore
 */
export const CultureInfoCaIT: CultureInfo = {
  name: 'ca-IT',
  displayName: 'català (Itàlia)',
  iso3LanguageCode: 'cat',
  iso2LanguageCode: 'ca',
  ietfLanguageTag: 'ca-IT',
  parent: CultureInfoCa
};
